import React, { useState } from "react";
import TaskDetails from "./taskDetails";
import AddTaskModal from "../../components/tasks/AddTaskModal";
import { useDispatch, useSelector } from "react-redux";
import { getAllUserInfo } from "../../Store/UserAction";
import TaskCalendar from "./Calender";
import jalaali from "jalaali-js";
import ChatBot from "../../components/ChatBot";
import { ArrowRight2 } from "iconsax-react";
import arrowRight from "../../assets/images/arrow-right.png";
import TaskListBox from "./taskListBox";

function TaskList() {
	// const [calendarShow, setCalendarShow] = useState(false)
	const [selectedTask, setSelectedTask] = useState(null);
	const [addTaskShow, setAddTaskShow] = useState(false);
	const userData = useSelector((state) => state.user.data);
	const dispatch = useDispatch();
	const [filter, setFilter] = useState("ongoing"); // 'ongoing' or 'completed'
	const [selectedDayTasks, setSelectedDayTasks] = useState([]);
	const [selectedDay, setSelectedDay] = useState(null);
	const [jalaliSelectedDay, setJalaliSelectedDay] = useState(null);
	const [calendarOpen, setCalendarOpen] = useState(false);
	const [taskListOpen, setTaskListOpen] = useState(true);
	const [chatbotOpen, setChatbotOpen] = useState(false);

	function openAddTaskModal() {
		setAddTaskShow(true);
		// dispatch(getAllUserInfo());
	}

	function closeAddTaskModal() {
		setAddTaskShow(false);
	}

	const fetchTasks = () => {
		dispatch(getAllUserInfo());
	};

	const filteredTasks =
		userData?.tasks?.filter((task) => {
			switch (filter) {
				case "ongoing":
					return !task.is_done;
				case "completed":
					return task.is_done;
				case "pending":
					return task.pending;

				default:
					return true;
			}
		}) || [];

	// const selectingTask = (id) => {
	//     const task = userData?.tasks?.find(task => task.id === id);
	//     if (task) {
	//         setSelectedTask(task);
	//     }
	// };

	const handleDayClick = (day) => {
		setJalaliSelectedDay(day);
		const { gy, gm, gd } = jalaali.toGregorian(day.year, day.month, day.day);
		const selectedDate = new Date(gy, gm - 1, gd);
		setSelectedDay(selectedDate);
		// Filter tasks for the selected day
		const filtered =
			userData?.tasks?.filter((task) => {
				const taskDate = new Date(task.deadline);
				return taskDate.toDateString() === selectedDate.toDateString();
			}) || [];
		setSelectedDayTasks(filtered);
		setFilter("selectedDay");
	};

	// const tasks = userData?.tasks || [];
	// const filteredTasks = tasks.filter(task =>
	//     filter === 'ongoing' ? !task.completed : task.completed
	// );

	const formatJalaaliDate = (day) => {
		return `${day.year}/${day.month}/${day.day}`;
	};

	// Persian date string for tab label
	const toPersianNumber = (n) =>
		n?.toString().replace(/\d/g, (d) => "۰۱۲۳۴۵۶۷۸۹"[d]);
	const getPersianDateLabel = (day) => {
		if (!day) return "";
		const j = jalaali.toJalaali(day);
		return `${toPersianNumber(j.jy)}/${toPersianNumber(j.jm)}/${toPersianNumber(j.jd)}`;
	};

	// Determine which tasks to show based on filter
	let tasksToShow = filteredTasks;
	if (filter === "selectedDay") {
		tasksToShow = selectedDayTasks;
	}

	// Tab title for header
	const tabTitle =
		filter === "ongoing" ? "تسک های در حال انجام" : "تسک های انجام شده";

	return (
		<>
			<div className="main-area">
				{/* Mobile task list accordion */}
				<div className="tasklist-accordion mobile-only">
					<button
						className="tasklist-toggle-btn"
						onClick={() => setTaskListOpen(!taskListOpen)}
					>
						<span>{tabTitle}</span>
						<img
							src={arrowRight}
							alt="arrow"
							className={`tasklist-toggle-arrow${taskListOpen ? " open" : ""}`}
							style={{
								width: 22,
								height: 22,
								marginLeft: 8,
								transition: "transform 0.25s",
							}}
						/>
					</button>
					<div
						className="tasklist-collapsible-content"
						style={{
							maxHeight: taskListOpen ? "900px" : "0",
							paddingBottom: taskListOpen ? "20px" : "0",
							transition:
								"max-height 0.35s cubic-bezier(.4,0,.2,1), padding-bottom 0.2s",
							overflow: "hidden",
						}}
					>
						{!selectedTask ? (
							<TaskListBox
								filteredTasks={tasksToShow}
								filter={filter}
								setFilter={setFilter}
								setSelectedTask={setSelectedTask}
								openAddTaskModal={openAddTaskModal}
								selectedDay={selectedDay}
								jalaliSelectedDay={jalaliSelectedDay}
								getPersianDateLabel={getPersianDateLabel}
								hasPending={userData?.tasks?.some((s) => s.pending)}
							/>
						) : (
							<div className="task-details-card">
								<button
									className="task-details-return-btn"
									onClick={() => setSelectedTask(null)}
								>
									<ArrowRight2
										size={20}
										color="#0052CC"
										style={{ marginLeft: 6 }}
									/>
									بازگشت به منو
								</button>
								<TaskDetails
									selectedTask={selectedTask}
									tasks={userData?.tasks}
									onTaskUpdated={fetchTasks}
									onTaskDeleted={fetchTasks}
								/>
							</div>
						)}
					</div>
				</div>

				{/* Mobile calendar accordion */}
				<div className="calendar-accordion mobile-only">
					<button
						className="calendar-toggle-btn"
						onClick={() => setCalendarOpen(!calendarOpen)}
					>
						<span>تقویم</span>
						<img
							src={arrowRight}
							alt="arrow"
							className={`calendar-toggle-arrow${calendarOpen ? " open" : ""}`}
							style={{
								width: 22,
								height: 22,
								marginLeft: 8,
								transition: "transform 0.25s",
							}}
						/>
					</button>
					<div
						className="calendar-collapsible-content"
						style={{
							maxHeight: calendarOpen ? "600px" : "0",
							transition: "max-height 0.35s cubic-bezier(.4,0,.2,1)",
							overflow: "hidden",
						}}
					>
						<div className="calendar-slide-content">
							<TaskCalendar
								tasks={userData?.tasks}
								selectedTask={selectedTask}
								onDayClick={handleDayClick}
							/>
						</div>
					</div>
				</div>

				{/* Mobile chatbot accordion */}
				<div className="calendar-accordion mobile-only">
					<button
						className="calendar-toggle-btn"
						onClick={() => setChatbotOpen(!chatbotOpen)}
					>
						<span>چت‌بات</span>

						<img
							src={arrowRight}
							alt="arrow"
							className={`chatbot-toggle-arrow${chatbotOpen ? " open" : ""}`}
							style={{
								width: 22,
								height: 22,
								marginLeft: 8,
								transition: "transform 0.25s",
							}}
						/>
					</button>
					<div
						className="chatbot-collapsible-content"
						style={{
							maxHeight: chatbotOpen ? "600px" : "0",
							transition: "max-height 0.35s cubic-bezier(.4,0,.2,1)",
							overflow: "hidden",
							background: "#fff",
							borderRadius: "0 0 16px 16px",
							boxShadow: "none",
							borderTop: "1.5px solid #E0E0E0",
							margin: 0,
							padding: 0,
						}}
					>
						<div className="chatbot-slide-content">
							{chatbotOpen && <ChatBot />}
						</div>
					</div>
				</div>

				<div className="main-container">
					<div className={`inbox-container`}>
						<div className="tasklist-container">
							{!selectedTask ? (
								<TaskListBox
									filteredTasks={tasksToShow}
									filter={filter}
									setFilter={setFilter}
									setSelectedTask={setSelectedTask}
									openAddTaskModal={openAddTaskModal}
									selectedDay={selectedDay}
									jalaliSelectedDay={jalaliSelectedDay}
									getPersianDateLabel={getPersianDateLabel}
									hasPending={userData?.tasks?.some((s) => s.pending)}
								/>
							) : (
								<div className="task-details-card">
									<button
										className="task-details-return-btn"
										onClick={() => setSelectedTask(null)}
									>
										<ArrowRight2
											size={20}
											color="#0052CC"
											style={{ marginLeft: 6 }}
										/>
										بازگشت به منو
									</button>
									<TaskDetails
										selectedTask={selectedTask}
										tasks={userData?.tasks}
										onTaskUpdated={fetchTasks}
										onTaskDeleted={fetchTasks}
									/>
								</div>
							)}
						</div>
					</div>

					<div className="task-details-calendar-container">
						<div className="task-details-container">
							<TaskDetails
								selectedTask={selectedTask}
								tasks={userData?.tasks}
								onTaskUpdated={fetchTasks}
								onTaskDeleted={fetchTasks}
							/>
						</div>
						<div className="calendar-container-outer">
							<TaskCalendar
								tasks={userData?.tasks}
								selectedTask={selectedTask}
								onDayClick={handleDayClick}
							/>
						</div>
						<div className="chatbot-container">
							<ChatBot />
						</div>
					</div>
				</div>
				<AddTaskModal show={addTaskShow} setShow={closeAddTaskModal} />
			</div>
		</>
	);
}

export default TaskList;
